import React from 'react';
import { useOnboardingContext } from 'contexts/OnboardingContext/OnboardingContext';
import OnboardingCoachmark from './OnboardingCoachmark';

const Onboarding: React.FC = (): JSX.Element | null => {
    const { state } = useOnboardingContext();
    const showOnboarding = state.walkThrough.length !== 0;

    if (!showOnboarding) {
        return null;
    }

    return <OnboardingCoachmark />;
};

export default Onboarding;
